<div class="oppgaver">
  @for (oppgave of oppgaver(); track oppgave.id;) {
    <oppgave-listevisning-kompakt [oppgave]="oppgave"/>
  }
</div>
